<template>
  <div>

    <breadcrumbs />

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ t.navigation.class }}
              </h6>
              <div class="element-box-tp">
                <newClass v-on:added="pushRow" />
                 <table class="table table-bordered table-lg table-v2 table-striped">
                   <thead>
                    <tr>
                      <th>Id</th>
                      <th>Name</th>
                      <th>Risk Template</th>
                    </tr>
                   </thead>
                   <draggable v-model="rows" @end="moved" :element="'tbody'">
                    <tr v-for="row in rows" :key="row.id">
                      <td class="w150">
                        # {{ row.id }}
                      </td>
                      <td>
                        <input type="text" class="form-control" @change="moved" v-model="row.name"/>
                      </td>
                      <td>
                        <select name="x" class="form-control" @change="moved" v-model="row.template.id">
                          <option v-for="t in templates" :value="t.id">{{ t.name }}</option>
                        </select>
                      </td>
                    </tr>
                   </draggable>
                 </table>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--------------------
START - Sidebar
-------------------->
      <div class="content-panel compact">
        <div class="content-panel-close" v-on:click="controlPanel()">
          <i class="os-icon os-icon-close"></i>
        </div>
        <div class="element-wrapper">
          <div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
            <span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
          </div>
          <h6 class="element-header" v-b-toggle.filter variant="primary">
            {{ t.filter.title }}
          </h6>
          <div class="element-box-tp">
            <b-collapse id="filter" class="mt-2">

            </b-collapse>
          </div>
        </div>

      </div>
      <!--------------------
      END - Sidebar
      -------------------->
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import newClass from '@/components/competition/form/newClass.vue'
  import feed from '@/mixins/feed.js'

  export default {
    name: 'classList',
    components: {newClass, draggable},
    mixins: [feed],
    data () {
      return {
        t: this.$root.t,
        rows: null,
        templates: []
      }
    },
    mounted () {
      this.getClass();

      this.fetchTemplates(2).then(response => {
        response.body.forEach((e) => {
          this.templates.push({name: e.name, id: e.id})
        });
      });
    },
    methods: {
      getClass () {
        this.fetchClass().then(response => {
          this.rows = response.body;
        }, response => {

        })
      },
      pushRow (r) {
          this.rows.push(r);
      },
      moved (m) {
          //onsole.log(this.rows[m.newIndex]);

        setTimeout(() => {
          this.rows.forEach((r, k) => {
            //r.template = r.template.id;
            r.order = k;
            this.openClass(r).then((response) =>{
              //r.template = response.body.template;
            })
          })
        }, 1000);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/competition/classList.vue